import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { ExamsService } from '../exams.service';
import { PatientsService } from '../patients.service';
import { Patient } from '../patients/patient';
import { Subject, Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';


@Component({
    selector: 'app-docpanel',
    templateUrl: './docpanel.component.html',
    styleUrls: ['./docpanel.component.scss'],
    standalone: false
})
export class DocpanelComponent implements OnInit, OnDestroy {
  showLogin = false;
  sub = new Subscription();
  private destroy$ = new Subject();
  showLimits = false;
 


  constructor(private http:HttpClient,public loginService: LoginService, public patS: PatientsService, private es: ExamsService) { }

  ngOnInit() {
    this.sub = this.loginService.export$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.export(data);
      }
    })
    
  }

  goDefaults() {
    let defaults = new Patient("default", "default", "defaults", "defaults");
    defaults.PID = 0;
    this.patS.setPat(defaults, true);
  }
  redirectAdministration(type) {
    this.http.post('/api/administration', { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }

  export(res) {
    this.sub = res.subscribe((data) =>{
      var element = document.createElement('a');
      // window.open('/api/stats/exportData')
      element.setAttribute('href','/api/stats/readydata');
      element.setAttribute('download', './test.csv');
      document.body.appendChild(element);
      element.click();
      setTimeout(() => {
        document.body.removeChild(element);
      },4000 );
      
      this.loginService.exportLoading = false;
      this.showLogin = false;
      
    })
  }

  logout(){
    this.loginService.clearCookies();
    this.loginService.Logout();
  }


  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.destroy$.next(undefined);
  }

  


  // countXmlFiles(hmo:string='Clalit'){
  //   const downloadUrl = `/api/gastro/countXmlFiles/${hmo}`;
  //   this.http.get(downloadUrl).subscribe(data => {
  //    this.xmlFilesCounter=data['count']
  //   }, error => {
  //     // Handle error
  //     console.error('Failed to countXmlFiles:', error);
  //     this.xmlFilesCounter=0
  //   });
  // }

}
